// extracted by mini-css-extract-plugin
export var completionBody = "_ji-2";
export var completionCard = "_ji-0";
export var completionFooter = "_ji-3";
export var completionTitle = "_ji-1";